import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueRx from "vue-rx";
import VuejsClipper from "vuejs-clipper";
import * as langs from "./utils/languages";

Vue.config.productionTip = false;
axios.defaults.baseURL = "/api";

Vue.use(VueRx);
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: true,
    clipperFixed: true
  }
});

async function preLoading() {
  try {
    const res = await fetch("languages/languages.json");
    langs.languages = (await res.json()) || [];
  } catch (err) {
    console.error(err);
  }
}

preLoading()
  .catch((err) => {
    console.error(err);
  })
  .finally(() => {
    new Vue({
      router,
      store,
      vuetify,
      VuejsClipper,
      render: h => h(App)
    }).$mount("#app");
  });
